import React from 'react';
import { Icon, SvgIconProps } from '@mui/material';

export type MUIFontIconName = string;

export interface ToggleIconProps {
  children: React.ReactElement<SvgIconProps> | MUIFontIconName;
  active?: boolean;
}

/**
 * 
 * Component to render an icon with a toggle state.
 * When active is true, the icon will be filled.
 * When active is false, the icon will be outlined.
 * For MUI icons, pass the icon name as a string.
 * For custom icons, pass the icon component.
 * Mui icons can be found at https://fonts.google.com/icons
 * 
 */
const ToggleIcon = ({ children, active }: ToggleIconProps) => {
  if (typeof children === 'string') {
    return <Icon
      data-test-id={`${children}-icon-${active ? 'active' : 'inactive'}`}
      baseClassName={active ? 'material-icons' : 'material-icons-outlined'}>
      {children}
    </Icon>;
  }
  return children;
};

export default ToggleIcon;